//
import { normalize } from 'normalizr';

import { simplApi } from '../../api/simplApi';
import { file } from './schemas';
import handleApiError from '../../helpers/handleApiError';
import { addFeedback } from './feedback';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_FILE = 'REQUEST_FILE';
export const RECEIVE_FILE = 'RECEIVE_FILE';
export const REMOVE_FILE = 'REMOVE_FILE';

// ------------------------------------
// Actions
// ------------------------------------

export function requestFile() {
  return {
    type: REQUEST_FILE,
  };
}

export function receiveFile(files) {
  return {
    type: RECEIVE_FILE,
    payload: {
      files,
    },
  };
}

export const fetchFile = () => dispatch => {
  dispatch(requestFile());

  return simplApi('file')
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        let preparedFiles;

        if (typeof json.id === 'undefined') {
          preparedFiles = normalize(json, [file]);
        } else {
          preparedFiles = normalize(json, file);
        }

        dispatch(receiveFile(preparedFiles.entities.files));
      }
    });
};

export function removeFile(fileId) {
  return {
    type: REMOVE_FILE,
    payload: fileId,
  };
}

export const deleteFile = fileId => dispatch => {
  const url = `file/${fileId}`;
  const options = { method: 'delete' };

  return simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }
        dispatch(handleApiError(json));
      } else {
        dispatch(removeFile(fileId));
        dispatch(addFeedback('warning', 'Datei gelöscht'));
      }
    });
};

export const actions = {
  requestFile,
  receiveFile,
  fetchFile,
  removeFile,
  deleteFile,
};

const FILE_ACTION_HANDLERS = {
  [REQUEST_FILE]: state => ({
    ...state,
    fetching: true,
  }),
  [RECEIVE_FILE]: (state, action) => {
    const stateFiles = state.files;

    _.forOwn(action.payload.files, (_file, id) => {
      const newFile = _file;

      if (typeof stateFiles[id] === 'object') {
        Object.assign(stateFiles[id], stateFiles[id], newFile);
      } else {
        stateFiles[id] = newFile;
      }
    });

    return {
      ...state,
      files: stateFiles,
      fetching: false,
    };
  },
  [REMOVE_FILE]: (state, action) => ({
    ...state,
    files: _.omit(state.files, action.payload),
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------

export const initialState = {
  fetching: false,
  current: null,
  formOpen: false,
  formTarget: null,
  files: {},
};
export default function fileReducer(state = initialState, action) {
  const handler = FILE_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/file.js